import invoiceTranslations from "@src/modules/client/modules/invoice/_langs/en-US";
import transactionTranslations from "@src/modules/client/modules/transaction/_langs/en-US";

export default {
  invoice: invoiceTranslations,
  transaction: transactionTranslations,
};
